<template>
  <div class="upload-detail-box">
    <span v-if="arrList && arrList.length === 1"
      ><i
        class="uploadfile-icon"
        v-if="/(.pdf)$/i.test(arrList[0].url)"
        @click="clickFile(arrList[0].url)"
      ></i>
      <i class="uploadfile-icon" v-else @click="showBigImg(arrList[0], 0)" :title="arrList[0].oldName"></i>
    </span>
    <a v-if="arrList && arrList.length > 1" @click="showMore">更多</a>
    <div class="show-pic" v-if="isShowPicBox">
      <picture-viewer
        v-if="lookImageData && lookImageData.length > 0"
        :imgData="lookImageData"
        :picIndex="showPicIndex"
        @close="isShowPicBox = false"
      ></picture-viewer>
    </div>
    <vxe-modal
      v-model="isShowMore"
      title="附件信息"
      width="450"
      height="300"
      resize
    >
      <div class="upload-detail-list clearfix">
        <ul>
          <li v-for="(item, index) in arrList" :key="index">
            <a v-if="/(.pdf)$/i.test(item.url)" @click="clickFile(item.url)"
              ><i></i
              ><span class="upload-detail-name">{{ item.oldName }}</span></a
            >
            <a v-else @click="showBigImg(item, index)"
              ><i></i
              ><span class="upload-detail-name">{{ item.oldName }}</span></a
            >
          </li>
        </ul>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import PictureViewer from "@/components/common/PictureViewer";
export default {
  components: {
    PictureViewer,
  },
  props: {
    arrList: Array,
    default: () => [],
  },
  data() {
    return {
      isShowPicBox: false,
      lookImageData: [],
      showPicIndex: 0,
      isShowMore: false,
    };
  },
  methods: {
    showBigImg(item, i) {
    // console.log(item, this.arrList);
      this.lookImageData = [];
      let arr = [];
      arr.push(item);
      this.arrList.forEach((item, index) => {
        let regPdf = /(.pdf)$/i;
        if (!regPdf.test(item.oldName)) {
          item.name = item.oldName;
          item.url;
          item.bigImgUrl = item.url;
          this.lookImageData.push(item);
          if (index == i) {
            this.showPicIndex = this.lookImageData.length - 1;
          }
        }
      });
      this.isShowPicBox = true;
    },
    clickFile(url) {
      window.open(url);
    },
    showMore() {
      this.isShowMore = true;
    },
  },
};
</script>

<style scoped>
.uploadfile-icon {
  display: block;
  width: 24px;
  height: 24px;
  margin: 0 auto;
  cursor: pointer;
  background: url("~assets/images/common/upload-icon.png") no-repeat;
  background-size: 24px auto;
}
.upload-detail-list li {
  height: 45px;
  margin: 4px 0;
}
.upload-detail-list li a {
  display: block;
  position: relative;
}
.upload-detail-list li i {
  display: inline-block;
  width: 45px;
  height: 45px;
  background: url("~assets/images/common/upload-icon.png") no-repeat;
  background-size: 45px auto;
  vertical-align: middle;
  margin: -3px 3px 0 0;
  position: absolute;
  left: 0;
  top: 0;
}

/* .upload-detail-title {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  text-align: center;
  color: white;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 0 10px;
  z-index: 999999;
  cursor: pointer;
  white-space: nowrap;
} */

/* .uploadfile-icon:hover .upload-detail-title {
  display: block;
} */
.upload-detail-name {
  width: 400px;
  height: 45px;
  word-break: break-all;
  box-sizing: border-box;
  padding-left: 45px;
  display: flex;
  align-items: left;
  justify-content: space-around;
  flex-direction: column;
  line-height: 14px;
}
.vxe-table
  .vxe-body--column.col--ellipsis:not(.col--actived)
  .vxe-cell
  .upload-detail-name {
  white-space: normal;
}
</style>